import { MixpanelPropertiesProvider, MixpanelProperty, PageViewTracker, usePageTitleUpdater } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";

const ProtectSource = {
    [MixpanelProperty.Source]: "ShareGate Protect"
};

export function ModuleGlobalProviders({ children }: PropsWithChildren) {
    usePageTitleUpdater();

    return (
        <MixpanelPropertiesProvider value={ProtectSource}>
            {children}
            <PageViewTracker />
        </MixpanelPropertiesProvider>
    );
}
